<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">
            {{ cost?.id ? t('Contact card add cost model heading text - (Contract control section) - Update cost') : t('Contact card add cost model heading text - (Contract control section) - Add cost') }}</h4>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="costForm" class="paddingForDetailView" (ngSubmit)="updateCost()">
        <div class="modal-body">
            <div class="row">
                <div class="col-xl-12 col-md-12 col-12 mb-1">
                    <label for="Description">{{ t('Contract control add cost modal description field title - (Contract
                        control section) - Description') }}</label>
                    <fieldset class="form-label-group mb-0">
                        <textarea 
                            class="form-control" 
                            id="label-textarea" 
                            formControlName="description" 
                            rows="3"
                            [ngClass]="{ 'is-invalid error': submitted && costForm.hasError('required', 'description') }"
                            [placeholder]="t('Contract control add cost modal description field placeholder - (Contract control section) - Description')">
                        </textarea>
                    </fieldset>
                    <div *ngIf="submitted && costForm.hasError('required', 'description')" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && costForm.hasError('required', 'description') }">
                         {{ t('Field required (form validation) - Field name is required', {fieldName: t("Contract control add cost modal description field title - (Contract
                        control section) - Description")}) }}
                    </div>
                </div>

                <div class="col-xl-6 col-md-6 col-12 mb-1 pe-50">
                    <div class="form-group mb-0">
                        <label for="Cost">{{ t('Cost card field title - (Contract control section) - Amount') }}</label>
                        <input 
                            type="number" 
                            class="form-control" 
                            formControlName="cost_amount"
                            [ngClass]="{ 'is-invalid error': submitted && costForm.hasError('required', 'cost_amount') }"
                            [placeholder]="t('Cost card field placeholder - (Contract control section) - Amount')" 
                        />
                        <div *ngIf="submitted && costForm.hasError('required', 'cost_amount')" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && costForm.hasError('required', 'cost_amount') }">
                            {{ t('Field required (form validation) - Field name is required', {fieldName: t("Cost card field title - (Contract control section) - Amount")}) }}
                        </div>
                        @if(form?.cost_amount?.value > 0 && form?.cost_converted_amount.value > 0 && systemCurrency !== form?.cost_currency?.value){
                            <span
                                class="convertedCost" 
                                placement="auto"
                                ngbTooltip="{{form?.conversion_rate?.value}} ({{form?.conversion_date?.value}})"
                                container="body">
                                {{form?.cost_converted_amount?.value}} {{systemCurrency}}
                            </span>
                        }
                    </div>
                </div>

                <div class="col-xl-6 col-md-6 col-12 mb-1 ps-50">
                    <div class="form-group mb-0">
                        <label for="cost-currency">{{ t('Cost card field title - (Contract control section) - Currency') }}</label>
                        <ng-select 
                            #SelectCurrency 
                            [items]="chooseCurrency" 
                            [clearable]="false" 
                            bindLabel="label"
                            bindValue="value" 
                            formControlName="cost_currency"
                            [searchable]="searchable"
                            [ngClass]="{ 'is-invalid error': submitted && costForm.hasError('required', 'cost_currency') }"
                        >
                            <ng-template ng-header-tmp>
                                <input class="form-control w-100" type="number"
                                    (input)="SelectCurrency.filter($event.target.value)" />
                            </ng-template>
                        </ng-select>
                        <div *ngIf="submitted && costForm.hasError('required', 'cost_currency')" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && costForm.hasError('required', 'cost_currency') }">
                            {{ t('Field required (form validation) - Field name is required', {fieldName: t("Cost card field title - (Contract control section) - Currency")}) }}
                        </div>
                    </div>
                </div>

                <div class="col-xl-12 col-md-12 col-12 mb-1">
                    <div class="form-group mb-0">
                        <label for="">{{ t('Cost card field title - (Contract control section) - Billing frequency') }}</label>
                        <ng-select 
                            [items]="billingFrequencyOptions" 
                            [clearable]="false" 
                            bindLabel="label"
                            bindValue="value"
                            [ngClass]="{ 'is-invalid error': submitted && costForm.hasError('required', 'billing_frequency') }"
                            formControlName="billing_frequency" 
                            [placeholder]="t('Cost card field title - (Contract control section) - Billing frequency')">
                        </ng-select>
                        <div *ngIf="submitted && costForm.hasError('required', 'billing_frequency')" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && costForm.hasError('required', 'billing_frequency') }">
                            {{ t('Field required (form validation) - Field name is required', {fieldName: t("Cost card field title - (Contract control section) - Billing frequency")}) }}
                        </div>
                    </div>
                </div>

                <div class="col-xl-6 col-md-6 col-12 mb-1  pe-50">
                    <div class="form-group">
                        <label for="first-name-icon">{{ t('Cost card field title - (Contract control section) - Billing Start Date') }}</label>
                        <div class="col-12 p-0">
                            <div class="CC_datePicker">
                                <input 
                                    type="text" 
                                    mwlFlatpickr 
                                    class="form-control" 
                                    [value]="form.billing_start.value"
                                    (change)="onBillingStartDateChange($event)"
                                    [altFormat]="(false | userTimeZoneFormat) | async"
                                    [altInput]="true"
                                    [convertModelValue]="true"
                                    [ngClass]="{ 'is-invalid error': submitted && costForm.hasError('required', 'billing_start') || submitted && costForm.hasError('startAfterEnd') }"
                                />
                                <div *ngIf="submitted && costForm.hasError('required', 'billing_start')" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && costForm.hasError('required', 'billing_start') }">
                                    {{ t('Field required (form validation) - Field name is required', {fieldName: t("Cost card field title - (Contract control section) - Billing Start Date")}) }}
                                </div>
                                <div *ngIf="submitted && costForm.hasError('startAfterEnd')" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && costForm.hasError('startAfterEnd') }">
                                   {{t('Cost card start date field validation error message - (Contract control section) - Start date cannot be after end date')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6 col-md-6 col-12 mb-1 ps-50">
                    <div class="form-group">
                        <label for="first-name-icon" class="text-muted position-relative" [ngClass]="{ 'text-muted': !costForm.get('has_billing_end_date')?.value }" class="position-relative">{{ t('Cost card field title - (Contract control section) - Billing End Date') }}
                            <div class="custom-control billing-end-date-checkbox custom-checkbox mt-50 mb-1" placement="auto" triggers="hover" [ngbTooltip]="t('Contract card add cost or revenue form checkbox tooltip text (Contract control section) - Enable Billing End Date')">
                                <input type="checkbox" formControlName="has_billing_end_date" class="custom-control-input" id="has_billing_end_date_cost"/>
                                <label class="custom-control-label" for="has_billing_end_date_cost"></label>
                            </div>
                        </label>
                        <div class="col-12 p-0 " [ngClass]="{ 'text-muted  pointer-none': !costForm.get('has_billing_end_date')?.value }">
                            <div class="CC_datePicker">
                                <input
                                    #billingEndPicker="mwlFlatpickr"
                                    type="text"
                                    mwlFlatpickr
                                    class="form-control"
                                    [value]="form.billing_end.value"
                                    (change)="onBillingEndDateChange($event)"
                                    [altInput]="true"
                                    [altFormat]="(false | userTimeZoneFormat) | async"
                                    [convertModelValue]="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal-footer">
            <button type="reset" class="btn btn-outline-secondary" (click)="closeModal()" rippleEffect>
                {{ t('Cancel button text (cancel button) - cancel') }}
            </button>
            @if(cost?.id && (hasFullAccess$ | async)) {
                <button type="button" class="btn btn-danger" (click)="deleteCost(cost?.id)" rippleEffect>
                    <span *ngIf="isDeleting$ | async" class="spinner-border spinner-border-sm me-1"></span>
                    {{ t('Delete (general) - Delete') }}
                </button>
            }
            <button type="submit" class="btn btn-primary me-0" [disabled]="isSaveDisabled$ | async" rippleEffect>
                 <span *ngIf="isCostLoading$ | async" class="spinner-border spinner-border-sm me-1"></span>
                {{ cost?.id ? t('Contact card plus icon for cost tooltip text - (Contract control section) - Update cost') : t('Contact card plus icon for cost tooltip text - (Contract control section) - Add cost') }}
            </button>
        </div>
    </form>
</ng-container>